export default "__VITE_ASSET__DiTjd6$D__"